import React, { useEffect } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import Cookies from 'universal-cookie'

const queryParams = new URLSearchParams(window.location.search)
const cookies = new Cookies()

const LoginRouter = (props) => {
  useEffect(() => {
    if (props.auth.user.id) {
      if (
        queryParams.get('nl') === 'y' &&
        props.auth.user.subscriptionType === null
      ) {
        // New login redirection
        if (props.auth.user.emailStatus === 'verified') {
          window.open('/onboarding?p=st', '_self')
        } else {
          window.open('/onboarding', '_self')
        }
      } else if (
        queryParams.get('nl') === 'y' &&
        props.auth.user.subscriptionType !== null &&
        props.auth.user.subscriptionType !== 'freemium' &&
        props.auth.user.membershipFeeStatus === 'pending'
      ) {
        // Redirection of account existing prior to Freemium launch
        const userData = {
          subscriptionType: null,
        }
        props.auth.updateUser(userData).then(() => {
          window.open('/onboarding', '_self')
        })
      } else {
        if (cookies.get('ls')) {
          // Login step redirection
          var nextStep =
            cookies.get('ls') === 'dc'
              ? (nextStep = '?s=mp')
              : (nextStep = '?s=' + cookies.get('ls'))
          window.open('/myfreebird' + nextStep, '_self')
        } else if (cookies.get('cs')) {
          // Community step redirection
          var nextStep = cookies.get('cs')
          window.open('/dashboard/community2?lp=' + nextStep, '_self')
        } else {
          window.open('/myfreebird', '_self')
        }
      }
    }
  }, [])
}

export default withRouter(withAuth(LoginRouter))
